import React, { useContext, useEffect } from "react";
import Hero from "../../Components/E-Commerces/Tipsy Monkey/Hero";
import Products from "../../Components/E-Commerces/Tipsy Monkey/Products";
import { AppContext } from "../../Contexts/AppContext";

const TipsyMonkey = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    localStorage.setItem("current", "commerce");
    context.setCurrent("commerce");
  }, [context]);
  return (
    <div>
      <Hero />
      <Products />
    </div>
  );
};

export default TipsyMonkey;
